
































































































import Vue from 'vue';
import vuex from '@/store';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Reports, User, Props, Global, Projects } from '@/store';
import cloneDeep from 'lodash/cloneDeep';
import FullViewReportPie from './components/reportPie/FullViewReportPie.vue';
import FullViewReportXY from './components/reportXY/FullViewReportXY.vue';
import FullViewReportBar from './components/reportBar/FullViewReportBar.vue';
import moment from 'moment-timezone';
import PropUtils from '@/modules/PropUtils';
import { fetchInstallationsLastMonth } from '@/store/modules/Projects';
import { event_consumption_anomalies_types, event_abnormal_types, event_consumption_during_day_types } from '@/store/modules/Global';

@Component({
  components: {
    FullViewReportPie,
    FullViewReportXY,
    FullViewReportBar
  }
})
class FullViewReports extends Vue {
  @User.State('isAuth') isAuth;
  @User.State('project') project;
  @Props.State('list') projectProperties;
  @Reports.State('reportsList') projectDevices;
  @Reports.State('devicesCount') devicesCount;
  @Global.State('lang') lang;
  @Global.State('overview_selected_tab') overview_selected_tab;
  @Global.State('timezone') projectTimezone;
  @Global.State('allProjectsTimezone') allProjectsTimezone;
  @Global.Mutation('setPageTitle') setPageTitle;
  @Global.Mutation('setOverviewSelectedTab') setOverviewSelectedTab;
  @Projects.State('list') projectsList;
  @Projects.State('projects_metadata') projectsMetadata;
  @Projects.State('projects_count') projectsCount;
  @Projects.State('projects_total_devices') projectsTotalDevices;
  @Projects.State('isLoadingProjectSummary') isLoadingProjectSummary;
  @Projects.State('isLoadingProjectsDevicesSummary') isLoadingProjectsDevicesSummary;
  @Projects.State('projectAlerts') projectAlerts;
  @Projects.State('alertsPriorityMetricsByCabinet') alertsPriorityMetricsByCabinet;
  @Projects.State('projectEvents') projectEvents;

  tab = 'tab-fullView';
  projects_chart = [];
  dates = [];
  weeklyDates = [];
  weeklyDevices = [{name: 'Devices', data: []}];
  commissionedLastMonth = [{name: 'Devices', data: []}];
  lastMonthCategories = [];
  barData = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        columnWidth: '30%',
        borderRadius: 8
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    yaxis: {
      labels: {
        formatter: (val) => {
          if (!isFinite(val)) return '0';
          return val.toFixed(0);
        }
      }
    },
    labels: [],
    fill: {
      opacity: 1
    }
  };
  power: Array<{ place: string, value: number }> = [];
  pole: Array<{ place: string, value: number }> = [];
  screw: Array<{ place: string, value: number }> = [];
  activity: Array<{ place: string, value: number }> = [];
  painted: Array<{ place: string, value: number }> = [];
  alerts_by_priority: Array<{ place: string, value: number }> = [];
  events_by_priority: Array<{ place: string, value: number }> = [];
  project_metadata: any = null;
  metadata_calculated = new Map();
  project_timezone: string | null = null;
  isCalculatingGraphs: boolean = true;

  mounted() {
    this.setPageTitle('Projects Overview');
    this.project_timezone = this.allProjects ? this.allProjectsTimezone : this.projectTimezone;
    if (!this.project_timezone) this.project_timezone = 'Asia/Tel_Aviv';
    
    // Defer heavy data processing to allow UI to render first
    this.$nextTick(() => {
      this.setProjectsChart();
      this.onProjectChange();
      this.getAlerts();
      this.getEvents();
      // Fetch installations graph from API
      if (this.project) {
        this.fetchInstallationsGraph();
      }
    });
  }

  get allProjects() {
    return this.project && this.project.id === 'allProjects';
  }

  @Watch('projectsList')
  @Watch('isLoadingProjectsDevicesSummary')
  setProjectsChart() {
    if (this.projectsCount !== this.projectsList.length) return;

    this.projects_chart = [];
    this.projectsList.forEach((project) => {
      this.projects_chart.push({
        pid: project.id,
        place: this.$t(project.name),
        value: this.isLoadingProjectsDevicesSummary ? 0 : this.projectsTotalDevices[project.id] || 0
      });
    });
  }

  @Watch('project')
  onProjectChange2() {
    if (this.project) {
      this.fetchInstallationsGraph();
    }
  }

  @Watch('project', { deep: true })
  @Watch('isLoadingProjectSummary')
  onProjectChange(){
    if (this.allProjects) {
      this.aggregateAllProjectsMetadata();
    } else {
      this.setProjectMetadata();
    }
  }

  aggregateAllProjectsMetadata(){
    if (this.isLoadingProjectSummary) return;
    if (!this.allProjects) return;
    
    const aggregated_metadata = {
      is_pole_painted: {},
      device_state_metrics: {},
      screw_type: {},
      pole_type: {},
      power_distribution_metrics: {}
    };

    [...this.projectsMetadata.entries()].forEach(([project_id, data]) => {
      Object.entries(data.is_pole_painted || {}).forEach(([key, value]) => {
        const count = typeof value === 'object' && value !== null ? (value as any).count : value as number;
        const name = typeof value === 'object' && value !== null ? (value as any).name : null;
        if (!aggregated_metadata.is_pole_painted[key]) {
          aggregated_metadata.is_pole_painted[key] = name ? { count: 0, name } : 0;
        }
        if (typeof aggregated_metadata.is_pole_painted[key] === 'object') {
          (aggregated_metadata.is_pole_painted[key] as any).count += count;
        } else {
          aggregated_metadata.is_pole_painted[key] = (aggregated_metadata.is_pole_painted[key] as number) + count;
        }
      });
      Object.entries(data.device_state_metrics || {}).forEach(([key, value]) => {
        const count = typeof value === 'object' && value !== null ? (value as any).count : value as number;
        const name = typeof value === 'object' && value !== null ? (value as any).name : null;
        if (!aggregated_metadata.device_state_metrics[key]) {
          aggregated_metadata.device_state_metrics[key] = name ? { count: 0, name } : 0;
        }
        if (typeof aggregated_metadata.device_state_metrics[key] === 'object') {
          (aggregated_metadata.device_state_metrics[key] as any).count += count;
        } else {
          aggregated_metadata.device_state_metrics[key] = (aggregated_metadata.device_state_metrics[key] as number) + count;
        }
      });
      Object.entries(data.screw_type || {}).forEach(([key, value]) => {
        const count = typeof value === 'object' && value !== null ? (value as any).count : value as number;
        const name = typeof value === 'object' && value !== null ? (value as any).name : null;
        if (!aggregated_metadata.screw_type[key]) {
          aggregated_metadata.screw_type[key] = name ? { count: 0, name } : 0;
        }
        if (typeof aggregated_metadata.screw_type[key] === 'object') {
          (aggregated_metadata.screw_type[key] as any).count += count;
        } else {
          aggregated_metadata.screw_type[key] = (aggregated_metadata.screw_type[key] as number) + count;
        }
      });
      Object.entries(data.pole_type || {}).forEach(([key, value]) => {
        const count = typeof value === 'object' && value !== null ? (value as any).count : value as number;
        const name = typeof value === 'object' && value !== null ? (value as any).name : null;
        if (!aggregated_metadata.pole_type[key]) {
          aggregated_metadata.pole_type[key] = name ? { count: 0, name } : 0;
        }
        if (typeof aggregated_metadata.pole_type[key] === 'object') {
          (aggregated_metadata.pole_type[key] as any).count += count;
        } else {
          aggregated_metadata.pole_type[key] = (aggregated_metadata.pole_type[key] as number) + count;
        }
      });
      Object.entries(data.power_distribution_metrics || {}).forEach(([key, value]) => {
        const count = typeof value === 'object' && value !== null ? (value as any).count : value as number;
        aggregated_metadata.power_distribution_metrics[key] = (aggregated_metadata.power_distribution_metrics[key] || 0) + count;
      });
    });

    this.setProjectMetadata(aggregated_metadata);
  }

  getFinalTypesList(chart_data){
    let final_chart_data = cloneDeep(chart_data);
    final_chart_data.sort((a, b) => b.value - a.value);
    
    // Find "None" in both English and Hebrew
    const noneIndex = final_chart_data.findIndex((type) => 
      type.place === 'None' || 
      type.place === this.$t('None')
    );
    
    let noneObject = null;
    if (noneIndex > -1){
      noneObject = final_chart_data[noneIndex];
      final_chart_data = final_chart_data.slice(0, noneIndex).concat(final_chart_data.slice(noneIndex + 1));
    }

    // Add None to the end if it exists and has a value
    if (noneObject && noneObject.value) final_chart_data.push(noneObject);

    return final_chart_data;
  }

  countTypes(types, chart_data){
    if (!chart_data.length) return types;
    
    const types_counter = cloneDeep(chart_data);
    types.forEach((type) => {
      const typeIndex = types_counter.findIndex((type_in_chart) => type_in_chart.place === type.place);
      typeIndex === -1 ? types_counter.push(type) : types_counter[typeIndex].value += type.value;
    });
    return types_counter;
  }

  setProjectMetadata(metadata = null){
    if (this.isLoadingProjectSummary) return;

    const project_metadata = metadata || (this.project && this.projectsMetadata.has(this.project.id) ? this.projectsMetadata.get(this.project.id) : null);
    
    if (!project_metadata || !project_metadata.device_state_metrics) return;

    // Helper function to extract count and name from value
    const extractValueAndName = (title: string, value: any) => {
      if (typeof value === 'object' && value !== null && value.hasOwnProperty('count') && value.hasOwnProperty('name')) {
        // New API format with count and name
        const translatedName = value.name[this.lang] || value.name.en || this.$t(PropUtils.getFieldLowerToUpper(title));
        return { place: translatedName, value: value.count };
      } else {
        // Old API format (just a number) - fallback to PropUtils translation
        return { place: this.$t(PropUtils.getFieldLowerToUpper(title)), value: value as number };
      }
    };

    // Only update pie charts, not the installations graph
    this.activity = this.getFinalTypesList(Object.entries(project_metadata.device_state_metrics || {}).map(([title, value]) => extractValueAndName(title, value)));
    this.painted = this.getFinalTypesList(Object.entries(project_metadata.is_pole_painted || {}).map(([title, value]) => extractValueAndName(title, value)));
    this.pole = this.getFinalTypesList(Object.entries(project_metadata.pole_type || {}).map(([title, value]) => extractValueAndName(title, value)));
    this.power = this.getFinalTypesList(Object.entries(project_metadata.power_distribution_metrics || {}).map(([title, value]) => extractValueAndName(title, value)));
    this.screw = this.getFinalTypesList(Object.entries(project_metadata.screw_type || {}).map(([title, value]) => extractValueAndName(title, value)));
  }

  async fetchInstallationsGraph() {
    try {
      this.isCalculatingGraphs = true;

      if (!this.project || !this.project.company) {
        console.warn('Project information not available');
        return;
      }

      let aggregatedData = {};

      if (this.allProjects) {
        // Fetch and aggregate data from all projects
        const fetchPromises = this.projectsList.map(async (project) => {
          try {
            const response = await fetchInstallationsLastMonth(project.company, project.id);
            return response;
          } catch (e) {
            console.error(`[fetchInstallationsGraph] Error fetching data for project ${project.id}:`, e);
            return null;
          }
        });

        const allResponses = await Promise.all(fetchPromises);

        // Aggregate data from all projects
        allResponses.forEach((response) => {
          if (response) {
            Object.entries(response).forEach(([date, counts]) => {
              if (!aggregatedData[date]) {
                aggregatedData[date] = { cabinet: 0, controller: 0 };
              }
              aggregatedData[date].cabinet += (counts as any).cabinet || 0;
              aggregatedData[date].controller += (counts as any).controller || 0;
            });
          }
        });
      } else {
        // Fetch data for single project
        if (!this.project.id) {
          console.warn('Project ID not available');
          return;
        }
        
        const response = await fetchInstallationsLastMonth(this.project.company, this.project.id);
        if (!response) {
          return;
        }
        aggregatedData = response;
      }

      if (!aggregatedData || Object.keys(aggregatedData).length === 0) {
        console.warn('No installations data available');
        return;
      }

      // Process response - format: { "15/12": { "cabinet": 0, "controller": 1 }, ... }
      const dates = Object.keys(aggregatedData).sort((a, b) => {
        const [dayA, monthA] = a.split('/').map(Number);
        const [dayB, monthB] = b.split('/').map(Number);
        
        // Use moment with project timezone for proper date handling
        const currentYear = moment.tz(this.project_timezone).year();
        const currentMonth = moment.tz(this.project_timezone).month() + 1;
        
        // If month is greater than current month, it's from previous year
        const yearA = monthA > currentMonth ? currentYear - 1 : currentYear;
        const yearB = monthB > currentMonth ? currentYear - 1 : currentYear;
        
        const dateA = moment.tz(`${yearA}-${monthA.toString().padStart(2, '0')}-${dayA.toString().padStart(2, '0')}`, this.project_timezone);
        const dateB = moment.tz(`${yearB}-${monthB.toString().padStart(2, '0')}-${dayB.toString().padStart(2, '0')}`, this.project_timezone);
        
        return dateA.valueOf() - dateB.valueOf();
      });

      // For ProjectsOverview (tab-fullView), display only controller counts
      const controllerCounts = dates.map(date => aggregatedData[date].controller || 0);
      
      // Get last 7 days for bar chart
      const last7Dates = dates.slice(-7);
      const last7ControllerCounts = last7Dates.map(date => aggregatedData[date].controller || 0);

      // Update bar chart data (last 7 days)
      this.barData.labels = last7Dates;
      this.weeklyDevices = [{ name: 'Controllers', data: last7ControllerCounts }];

      // Update line chart data (last 30 days - daily counts, not cumulative)
      this.lastMonthCategories = dates;
      this.commissionedLastMonth = [{ name: 'Controllers', data: controllerCounts }];

    } catch (e) {
      console.error('[fetchInstallationsGraph] Error:', e);
    } finally {
      this.isCalculatingGraphs = false;
    }
  }

  @Watch('projectAlerts', { deep: true })
  getAlerts() {
    let high_priority = 0; // priority = 3
    let medium_priority = 0;  // priority = 2
    let low_priority = 0;  // priority = 1

    for (const cabinet_metric of this.alertsPriorityMetricsByCabinet.values()) {
      if (cabinet_metric.top_priority >= 1 && cabinet_metric.top_priority <= 3) {
        if (cabinet_metric.top_priority === 1) low_priority++;
        else if (cabinet_metric.top_priority === 2) medium_priority++;
        else high_priority++;
      }
    }

    this.alerts_by_priority = [
      { place: this.$t('High priority'), value: high_priority},
      { place: this.$t('Medium priority'), value: medium_priority},
      { place: this.$t('Low priority'), value: low_priority}
    ];
  }

  @Watch('projectEvents', { deep: true })
  getEvents() {
    let high_priority = 0; // category = consumption_anomalies 
    let medium_priority = 0;  // category = abnormal_data
    let low_priority = 0;  // category = consumption_during_day

    this.projectEvents.forEach((incident) => {
      if (event_consumption_anomalies_types.includes(incident.event_type)){
        high_priority++;
      }else if (event_abnormal_types.includes(incident.event_type)){
        medium_priority++;
      }else if (event_consumption_during_day_types.includes(incident.event_type)){
        low_priority++;
      } else {
        low_priority++;
      }
    });
    this.events_by_priority = [
      { place: this.$t('High priority'), value: high_priority},
      { place: this.$t('Medium priority'), value: medium_priority},
      { place: this.$t('Low priority'), value: low_priority}
    ];
  }
}

export default FullViewReports;
